import { INDRAApiService } from '@ibe.services/api.indra.service';
import { HttpClient } from '@angular/common/http';
import { MOCK_STATUS, URL_BFM_PNRS_SEARCH, MOCK_URL_BFM_BOOKED_TRIPS_LIST, MOCK_URL_BFM_BOOKED_TRIP_SEARCH, URL_BFM_PNRS_LIST } from '@ibe.config';
import * as i0 from "@angular/core";
import * as i1 from "./api.indra.service";
import * as i2 from "@angular/common/http";
var INDRARetrievePnrService = /** @class */ (function () {
    function INDRARetrievePnrService(api, http) {
        this.api = api;
        this.http = http;
    }
    INDRARetrievePnrService.prototype.INDRA_getPNRList = function (tapID) {
        var RETRIEVE_BOOKING_LIST = URL_BFM_PNRS_LIST + '?email=xxx&status=All&tapID=';
        if (MOCK_STATUS.BOOKING_LIST) {
            return this.http.get(MOCK_URL_BFM_BOOKED_TRIPS_LIST);
        }
        else {
            return this.api.INDRA_get(RETRIEVE_BOOKING_LIST + tapID);
        }
    };
    INDRARetrievePnrService.prototype.INDRA_getPNRListByStatus = function (status) {
        var RETRIEVE_BOOKING_LIST = URL_BFM_PNRS_LIST + '?status=' + status;
        if (MOCK_STATUS.BOOKING_LIST) {
            return this.http.get(MOCK_URL_BFM_BOOKED_TRIPS_LIST);
        }
        else {
            return this.api.INDRA_get(RETRIEVE_BOOKING_LIST);
        }
    };
    //TODO Update the model for observable.
    INDRARetrievePnrService.prototype.INDRA_searchPNR = function (documentNumber, lastname) {
        if (MOCK_STATUS.BOOKING_SEARCH) {
            return this.http.get(MOCK_URL_BFM_BOOKED_TRIP_SEARCH);
        }
        else {
            var data = {
                "lastName": lastname
            };
            if (documentNumber.length === 6) {
                data['pnrNumber'] = documentNumber;
            }
            else {
                data['ticketNumber'] = documentNumber;
            }
            return this.api.INDRA_post(URL_BFM_PNRS_SEARCH + "?skipAncillariesCatalogue=true", data);
        }
    };
    INDRARetrievePnrService.ngInjectableDef = i0.defineInjectable({ factory: function INDRARetrievePnrService_Factory() { return new INDRARetrievePnrService(i0.inject(i1.INDRAApiService), i0.inject(i2.HttpClient)); }, token: INDRARetrievePnrService, providedIn: "root" });
    return INDRARetrievePnrService;
}());
export { INDRARetrievePnrService };
